import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { obtenerInventarios, historialComprasFolios, historialEntregasHologramas } from '../../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { v4 as uuidv4 } from 'uuid';

const PanelInventarioComponent = () => {

    const dispatch = useDispatch()
    const inventarios = useSelector(store => store.ModuloInventario.data)

    React.useEffect(async () => {
        await dispatch(obtenerInventarios())
    }, [])

    const columns = [
        { field: 'numAsociado', headerName: 'Número de asociado', headerAlign: 'center', width: 200 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 550 },
        { field: 'invMezcal', headerName: 'Inventario mezcal', headerAlign: 'center', width: 200 },
        { field: 'invBebidasMezcal', headerName: 'Inventario bebidas con mezcal', headerAlign: 'center', width: 250 },
    ]

    const rows = []

    inventarios?.map(anexo => {
        let hologramasmezcal = ''
        if (anexo?.hologramasmezcal != '') hologramasmezcal = anexo?.hologramasmezcal
        else hologramasmezcal = '0'
        let hologramasbebidas = ''
        if (anexo?.hologramasbebidas != '') hologramasbebidas = anexo?.hologramasbebidas
        else hologramasbebidas = '0'
        rows.push({
            id: uuidv4(), numAsociado: anexo?.cliente?.numerosocio, razonSocial: anexo?.cliente?.nombrerazonsocial,
            invMezcal: hologramasmezcal, invBebidasMezcal: hologramasbebidas, idloginfc40_solicitudadquisicionholo: anexo?.cliente?.idlogin
        })
    })


    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    return (
        <div className="container">
            <Box sx={{ height: 530, width: '100%', mt: 7}}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableColumnMenu={true}
                    components={{ Toolbar: QuickSearchToolbar }}
                    pageSize={10}
                    sx={{
                        boxShadow: 0,
                        color: 'black',
                        border: 0,
                        backgroundColor: 'white',
                        '& .MuiDataGrid-cell': {
                            display: 'block',
                            position: 'relative',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#CD973D',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            height: '20px'
                        }
                    }}
                />
            </Box>
        </div>
    );

};
export default PanelInventarioComponent